/**
 * Question sets that are backed by the Car API.
 *
 * A set is a trio of Admiral question IDs (year, make, model). A question only
 * uses the Car API when every question in its set is present as a select.
 * The same IDs are used in every environment.
 */
const buildCarQuestionSet = ({ year, make, model }) => ({
  [year]: {
    type: 'getYears',
    requestField: 'vehicle_year',
    requiresDataFrom: [make, model],
  },
  [make]: {
    type: 'getMakes',
    requestField: 'vehicle_make',
    requiresDataFrom: [year, model],
  },
  [model]: {
    type: 'getModels',
    requestField: 'vehicle_model',
    requiresDataFrom: [year, make],
  },
});

const carQuestionSets = [
  buildCarQuestionSet({
    year: '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
    make: 'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
    model: '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
  }),
  buildCarQuestionSet({
    year: 'c201225e-a625-11f1-8087-06ddfea17a4b',
    make: 'cdeb9127-a625-11f1-8087-06ddfea17a4b',
    model: 'db17b195-a625-11f1-8087-06ddfea17a4b',
  }),
];

export default carQuestionSets;
